<template>
	<modal
		class="pickup-modal"
		size="large"
		:full="true"
		@close="$emit('close')">
		<template slot="header">
			<h3>
				<i class="material-icons text-primary">local_shipping</i>
				<b>Ostock Shipment</b>
			</h3>
		</template>
		<template slot="body">
			<div class="container-fluid">
				<div class="row">
					<div class="col-lg-8 p-0">
						<div class="">
							<img
								src="https://cdn.orderonline.id/img/pickup-cod.gif"
								class="img-responsive w-100"
								alt="Pickup Illustration">
						</div>
						<div class="modal-body">
							<div class="alert alert-info">{{ orders.length }} {{ $t('Selected Orders') }}</div>
							<div
								class="alert alert-danger"
								v-if="invalidOrders.length > 0">
								<!-- <div>Your selected orders <b>includes non-COD</b> or already picked up before:</div> -->
								<div>{{ invalidOrders.length }} Order yang anda pilih <b>memiliki Non-COD yang tidak menggunakan E-Payment dan sudah Paid</b> atau telah di-kirim sebelumnya:</div>
								<div>{{ invalidOrders.map(({order_id}) => order_id).join(', ') }}</div>
								<div class="text-right">
									<button
										class="btn btn-dark btn-sm mt-2"
										type="button"
										@click="unselectInvalidOrders">
										{{ $t('Remove from Selected Orders') }}
									</button>
								</div>
							</div>
							<!-- Invalid Orders Courier -->
							<div
								class="alert alert-danger"
								v-if="invalidOrdersCourier.length > 0">
								<!-- <div>Your selected orders <b>includes non-COD</b> or already picked up before:</div> -->
								<div>{{ invalidOrdersCourier.length }} Order yang anda pilih tidak menggunakan kurir {{ selectedCourierLabel }}:</div>
								<div>{{ invalidOrdersCourier.map(({order_id}) => order_id).join(', ') }}</div>
							</div>
							<!-- Invalid Orders Address -->
							<div
								class="alert alert-danger"
								v-if="invalidOrdersAddress.length > 0">
								<!-- <div>Your selected orders <b>includes non-COD</b> or already picked up before:</div> -->
								<div>{{ invalidOrdersAddress.length }} Order yang anda pilih tidak memiliki alamat</div>
								<div>{{ invalidOrdersAddress.map(({order_id}) => order_id).join(', ') }}</div>
							</div>
							<div class="alert alert-info hidden">
								Rata-rata kurir untuk pickup akan datang 2 jam setelah waktu pickup yang dipilih
							</div>
							<div class="alert alert-info" v-if="invalidOrders.length === 0 && invalidOrdersCourier.length === 0 && selectedCourier === 'sicepat'">
								<p><b>SiCepat</b> menyediakan metode pembayaran <b>cashless</b> untuk paket COD, melalui scan barcode di aplikasi kurir.</p>
								<p>Channel pembayaran yang tersedia: <b>OVO, DANA, ShopeePay, Gopay</b> & semua <b>Mobile Banking (Scan by QR Code)</b>.</p>
								Jika ada pembeli yang transfer langsung ke seller, maka dengan berat hati paket akan di retur otomatis.
							</div>
							<!-- Orders Treshold Error -->
							<div class="alert alert-warning" v-if="!isOrdersTresholdValid">
								<div>Untuk menggunakan pickup {{ selectedCourierLabel }} anda harus memilih minimal <b>5 Order</b></div>
							</div>
							<!-- Courier -->
							<div class="mb-4">
								<label class="font-weight-bold">{{ $t('Courier') }}</label>
								<div class="row">
									<div
										class="col-6 col-md-4"
										v-for="(courier, index) in availableCouriers"
										:key="index">
										<div class="shipping-couriers well mb-3">
											<label class="custom-control custom-radio mb-0 cur-p">
												<input
													type="radio"
													name="courier"
													class="custom-control-input"
													:value="courier.key"
													v-model="selectedCourier">
												<div
													class="custom-control-label shipping-logo"
													:class="`shipping-logo-${courier.key}`"
													:title="courier.label"
													:style="{ backgroundImage: `url('/images/logo-${courier.key}.png')`}">
												</div>
											</label>
										</div>
									</div>
								</div>
							</div>
							<!-- Method -->
							<div class="form-group">
								<label class="font-weight-bold">{{ $t('Shipment Method') }}</label>
								<select
									class="form-control"
									:disabled="selectedCourier === 'jne'"
									v-model="method">
									<option
										v-for="methodOption in methods"
										:key="methodOption.value"
										:value="methodOption.value">
										{{ methodOption.label }}
									</option>
								</select>
							</div>
							<!-- Warehouses -->
							<warehouse-select
								@input="onWarehouseSelected"
							/>
							<!-- Locations -->
							<place-editor
								:province-id.sync="provinceId"
								:province-name.sync="provinceName"
								:city-id.sync="cityId"
								:city-name.sync="cityName"
								:subdistrict.sync="subdistrict"
								:subdistrict-id.sync="subdistrictId"
								:subdistrict-name.sync="subdistrictName"
								:zip.sync="zip"
								:origin.sync="origin"
								:courier="selectedCourier"
								:method="method"
								v-if="isDataComplete">
							</place-editor>
							<!-- Error / Courier Not Support in the selected city yet -->
							<div
								class="alert alert-warning"
								v-if="isNotSupported">
								{{ courierErrorLabel }}
							</div>
							<div class="row">
								<div class="col-sm-6">
									<!-- Phone -->
									<div class="form-group">
										<label class="font-weight-bold">{{ $t('Phone Number') }}</label>
										<input type="text" class="form-control" v-model="phoneNumber">
										<div
											class="text-danger mt-2"
											v-if="!phoneNumber || phoneNumber.trim() === ''">
											{{ $t('Phone is required') }}
										</div>
										<small class="text-grey-dark">Pastikan nomor yang anda masukkan adalah nomor yang valid</small>
									</div>
								</div>
								<div class="col-sm-6">
									<!-- Phone Alternative -->
									<div class="form-group">
										<label class="font-weight-bold">{{ $t('Secondary Phone Number') }}</label>
										<input type="text" class="form-control" v-model="phoneNumberAlt">
										<div
											class="text-danger mt-2"
											v-if="!phoneNumberAlt || phoneNumberAlt.trim() === ''">
											{{ $t('Secondary Phone is required') }}
										</div>
										<small class="text-grey-dark">Kurir akan menghubungi nomor ini, apabila nomor utama tidak dapat dihubungi</small>
									</div>
								</div>
							</div>
							<!-- Address -->
							<div class="form-group">
								<label class="font-weight-bold">{{ $t('Pickup Location Address') }}</label>
								<textarea
									class="form-control"
									placeholder="Masukkan alamat lokasi pickup dengan lengkap beserta patokan di sekitar lokasi, agar pihak kurir dapat sampai dengan cepat di lokasi."
									v-model="address">
								</textarea>
								<small class="text-grey-dark">Masukkan alamat lokasi pickup dengan lengkap beserta patokan, untuk memudahkan pihak kurir</small>
								<div
									class="text-danger mt-2"
									v-if="!address || address.trim() === ''">
									{{ $t('Address is required') }}
								</div>
							</div>
							<div class="row">
								<!-- Date -->
								<div class="col-sm-6">
									<div class="form-group">
										<label class="font-weight-bold" v-if="isPickup">{{ $t('Pickup Date') }}</label>
										<label class="font-weight-bold" v-if="isDrop">{{ $t('Drop Date') }}</label>
										<input
											type="date"
											class="form-control"
											:min="minDate"
											:max="maxDate"
											v-model="date"
										>
									</div>
								</div>
								<!-- Time -->
								<div class="col-sm-6">
									<div class="form-group">
										<label class="font-weight-bold" v-if="isPickup">{{ $t('Pickup Time') }}</label>
										<label class="font-weight-bold" v-if="isDrop">{{ $t('Drop Time') }}</label>
										<input
											type="time"
											class="form-control"
											:min="minTime"
											:max="maxTime"
											v-model="time"
											@change="onTimeChange"
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Notes -->
					<div class="side-notes col-lg-4 pt-3">
						<div class="text-bold mb-3 flex-center">
							<i class="material-icons mr-2 text-warning">emoji_objects</i>
							<span>Ketentuan Pickup</span>
						</div>
						<ul class="pl-4">
							<!-- <li class="mb-2">Wajib menggunakan Shipping Label dari Ostock</li> -->
							<!-- <li class="mb-2">Siapkan paket, paling tidak 30 menit sebelum waktu pickup yang telah dipilih</li> -->
							<li class="mb-2">Wajib menggunakan Shipping Label dari Ostock yang didownload setelah melakukan permintaan Pickup, dan pastikan di Shipping Label tersebut terdapat Barcode pengiriman</li>
							<li class="mb-2"><b>No resi</b> akan terbit secara <b>otomatis</b> setelah melakukan Pickup, sehingga tidak perlu lagi mengupdate no resi terhadap masing-masing orderan yang di-Pickup</li>
							<li class="mb-2">Apabila memiliki alamat pickup yang sama, sebaiknya lakukan 1x request pickup untuk beberapa order.</li>
							<li class="mb-2">Jangan lupa untuk selalu meminta bukti serah terima dari kurir yang melakukan pickup</li>
							<!-- <li class="mb-2">Maksimal besaran biaya penggantian untuk <b>paket yang hilang</b> adalah sebesar Rp500.000</li> -->
							<li class="mb-2">Pickup <b>Non-COD</b> harus menggunakan <b>E-Payment</b> dan sudah <b>Paid</b></li>
						</ul>
					</div>
				</div>
			</div>
		</template>
		<template slot="footer">
			<button
				class="btn btn-light"
				@click="$emit('close')">
				{{ $t('Cancel') }}
			</button>
			<button
				class="btn btn-primary"
				:class="{ 'is-loading': isSubmitting }"
				:disabled="!isValid"
				@click="submit">
				{{ $t('Request Pickup') }}
			</button>
		</template>
	</modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import Modal from '@/components/Modal.vue';
import PlaceEditor from '@/components/PlaceEditor.vue';
import WarehouseSelect from '@/components/WarehouseSelect.vue';
import { shippingCouriers } from '@/lib/statics';
import {
	getAxiosErrorMessage,
	duplicateVar,
} from '@/lib/helper';
import shippingApi from '@/api/shipping';

const SHIPMENT_METHODS = {
	PICKUP: 'PICKUP',
	DROP: 'DROP',
};

export default {
	name: 'PickupModal',
	props: {
		orders: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		Modal,
		PlaceEditor,
		WarehouseSelect,
	},
	data() {
		return {
			address: '',
			zip: 0,
			date: null,
			time: '10:00',
			selectedCourier: 'sicepat',
			isSubmitting: false,
			format: 'YYYY-MM-DD',
			isDataComplete: false,
			provinceId: 0,
			provinceName: '',
			cityId: 0,
			cityName: '',
			subdistrict: null,
			subdistrictId: 0,
			subdistrictName: '',
			origin: '',
			phoneNumber: '',
			phoneNumberAlt: '',
			warehouse: null,
			// invalidOrders: [],
			method: 'PICKUP',
			methods: [
				{ value: 'PICKUP', label: 'Pickup' },
				{ value: 'DROP', label: 'Drop' },
			],
		};
	},
	methods: {
		...mapActions({
			updateStore: 'updateStore',
		}),
		setData() {
			// this.setInvalidOrders();
			this.setPickup();
			this.initDateTime();
			this.isDataComplete = true;
		},
		setPickup() {
			this.address = this.store.address || '';
			this.phoneNumber = this.store.phone || '';

			const shippingOrigin = this.store.shipping.origin;
			this.provinceId = shippingOrigin.province.id;
			this.provinceName = shippingOrigin.province.name;
			this.cityId = shippingOrigin.city.id;
			this.cityName = shippingOrigin.city.name;
			this.subdistrictId = shippingOrigin.subdistrict.id;
			this.subdistrictName = shippingOrigin.subdistrict.name;

			if (this.store) {
				const pickupPhone = this.store.pickup_phone || '';
				const pickupPhoneAlt = this.store.pickup_phone_alt || '';
				if (pickupPhone !== '') {
					this.phoneNumber = pickupPhone;
				}
				if (pickupPhoneAlt !== '') {
					this.phoneNumberAlt = pickupPhoneAlt;
				}
			}
		},
		saveStorePickupInfo() {
			const store = duplicateVar(this.store);
			store.pickup_phone = this.phoneNumber;
			store.pickup_phone_alt = this.phoneNumberAlt;
			const cb = () => {};
			const errorCb = () => {};
			this.updateStore({ store, cb, errorCb });
		},
		submit() {
			this.isSubmitting = true;

			this.saveStorePickupInfo();

			const params = this.params;
			const callback = (response) => {
				const orders = response.data;
				const pickup = {
					pickup_date: this.date,
					pickup_time: this.time,
				};
				const courier = this.selectedCourier;
				const payload = { orders, pickup, courier };
				this.$emit('success', payload);
				const message = response.message;
				const notifType = orders.length === 0 ? 'warn' : 'success';
				this.$notify({
					group: 'app',
					type: notifType,
					title: 'Pickup Request',
					text: message,
				});
				this.$emit('close');
				this.isSubmitting = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Pickup Request',
					text: message,
				});
				this.isSubmitting = false;
			};
			shippingApi.requestPickup(params, callback, errorCallback);

			const totalOrders = this.orders.length;

			// Track
			this.$gtm.trackEvent({
				event: 'interaction',
				category: 'Logistic',
				action: 'click',
				label: 'Request Pickup',
				value: totalOrders,
				noninteraction: true, // Optional
			});
			this.$track('LOGISTIC_REQUEST_PICKUP');
		},
		onTimeChange(event) {
			const time = event.target.value;
			// const values = value.split(':');
			// const valueHour = parseInt(values[0]);
			// const valueMinute = parseInt(values[1]);
			this.checkTime(time);
		},
		checkTime(time) {
			let selectedDate = dayjs(`${this.date} ${time}`);
			if (
				(selectedDate.hour() === this.courierMaxTime && selectedDate.minute() > 0)
				|| (selectedDate.hour() > this.courierMaxTime)
			) {
				selectedDate = selectedDate.set('minute', 0);
				const hourLabel = this.courierMaxTime < 10 ? `0${this.courierMaxTime}` : `${this.courierMaxTime}`;
				this.time = `${hourLabel}:00`;
			}
			const currentDate = dayjs();
			if (currentDate.isAfter(selectedDate, 'second')) {
				const selectedTime = currentDate.format('HH:mm');
				this.time = selectedTime;
			}
		},
		getCourierLabel(courier) {
			const index = shippingCouriers.findIndex(({ key }) => key === courier);
			return index !== -1 ? shippingCouriers[index].label : courier;
		},
		initDateTime() {
			const date = dayjs();
			const currentHour = date.hour();
			this.date = currentHour >= this.hourTreshold
				? date.add(1, 'day').format(this.format)
				: date.format(this.format);

			this.time = duplicateVar(this.minTime);
		},
		onWarehouseSelected(warehouse) {
			this.warehouse = warehouse;

			if (this.warehouse) {
				// set selected warehouse to pickup
				this.provinceId = warehouse.province.id;
				this.provinceName = warehouse.province.name;
				this.cityId = warehouse.city.id;
				this.cityName = warehouse.city.name;
				this.subdistrictId = warehouse.subdistrict.id;
				this.subdistrictName = warehouse.subdistrict.name;
				this.phoneNumber = warehouse.phone_primary;
				this.phoneNumberAlt = warehouse.phone_secondary;
				this.address = warehouse.address;
				this.zip = warehouse.zip;
				this.isDataComplete = true;
			}
		},
		unselectInvalidOrders() {
			const ids = this.invalidOrders.map(({ _id }) => _id);
			this.$emit('unselect', ids);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			store: 'store',
			isAdmin: 'isAdmin',
			isTester: 'isTester',
			isHasFeature: 'isHasFeature',
		}),
		invalidOrders() {
			const allowedServices = ['OKE', 'REG', 'CTC', 'EZ', 'EZGG', 'UDRREG', 'STANDARD'];
			// const filter = order => !order.shipping.cod || !!order.shipping.pickup;
			// const userId = this.user._id;
			const canUseBankTransfer = this.isHasFeature('shipment_bank_transfer');
			const filter = (order) => {
				const paymentMethod = order?.payment?.method ?? 'bank_transfer';
				const paymentStatus = order?.payment?.status ?? 'unpaid';
				// eslint-disable-next-line camelcase
				const paymentShippingDeducted = order?.payment?.shipping_deducted ?? false;
				const isPaid = paymentStatus === 'paid';
				const isInstant = paymentMethod === 'instant' && isPaid && paymentShippingDeducted;
				const isBankTransfer = paymentMethod === 'bank_transfer';
				const isBankTransferValid = isBankTransfer && canUseBankTransfer;
				const service = order?.shipping?.service ?? '-';
				const isServiceValid = allowedServices.includes(service);
				const isCodValid = order.shipping.cod && isServiceValid;
				const validPaymentMethod = isCodValid || isInstant || isBankTransferValid;
				const alreadyPickedUp = !!order.shipping.pickup;
				const isInvalid = !validPaymentMethod || alreadyPickedUp;
				return isInvalid;
			};
			const invalidOrders = this.orders.filter(filter);
			return invalidOrders;
		},
		invalidOrdersCourier() {
			let selectedCourier = this.selectedCourier;
			if (selectedCourier === 'jnt') {
				selectedCourier = 'J&T';
			}
			const filter = (order) => {
				let isInvalid = !order.shipping.courier || order.shipping.courier !== selectedCourier;
				if (order.type === 'storefront' && order.shipping_origin === 'product') {
					const shippingCosts = order.shipping_costs;
					const invalidCouriers = shippingCosts.filter(({ courier }) => courier !== selectedCourier);
					isInvalid = invalidCouriers.length > 0;
				}
				return isInvalid;
			};
			return this.orders.filter(filter);
		},
		availableCouriers() {
			const partners = [
				'sicepat',
				'sap',
				'jne',
				'jnt',
			];
			if (this.isAdmin || this.isHasFeature('pickup_ninja')) {
				partners.push('ninja');
			}
			return shippingCouriers.filter(({ key }) => partners.includes(key));
		},
		minTime() {
			const limit = dayjs()
				.set('hour', 9)
				.set('minute', 0)
				.set('second', 0);

			const currentDay = dayjs();
			const currentHour = currentDay.hour();
			const currentMinute = currentDay.minute();
			const currentHourLabel = currentHour < 10 ? `0${currentHour}` : `${currentHour}`;
			const currentMinuteLabel = currentMinute < 10 ? `0${currentMinute}` : `${currentMinute}`;
			const isDateSame = currentDay.isSame(dayjs(this.date), 'day');
			const isAfterLimit = currentDay.isAfter(limit, 'second');
			const time = isDateSame && isAfterLimit ? `${currentHourLabel}:${currentMinuteLabel}` : '09:00';
			return time;
		},
		maxTime() {
			const hourLabel = this.courierMaxTime < 10 ? `0${this.courierMaxTime}` : `${this.courierMaxTime}`;
			return `${hourLabel}:00`;
		},
		courierMaxTime() {
			let maxTime = 21;
			const courier = this.selectedCourier;
			if (courier === 'sicepat') {
				maxTime = 21;
			} else if (courier === 'jne') {
				maxTime = 17;
			}
			return maxTime;
		},
		// API Cut Off max time
		hourTreshold() {
			const hourTreshold = 15;
			// if (this.selectedCourier === 'jne') {
			// 	hourTreshold = 11; // cut off api
			// 	const isPickupAtJakarta = this.subdistrict && this.subdistrict.jne_destination.includes('CGK');
			// 	if (isPickupAtJakarta) {
			// 		hourTreshold = 15;
			// 	}
			// }
			return hourTreshold;
		},
		minDate() {
			const date = dayjs();
			const currentHour = date.hour();
			const dayLimit = currentHour >= this.hourTreshold ? 1 : 0;
			return date.add(dayLimit, 'day').format(this.format);
		},
		maxDate() {
			return dayjs().add(1, 'days').format(this.format);
		},
		params() {
			// eslint-disable-next-line camelcase
			const orderIds = this.orders.map(({ order_id }) => order_id);
			const idsJson = JSON.stringify(orderIds);
			const address = this.address.trim();
			const phoneNumber = this.phoneNumber.trim();
			const phoneNumberAlt = this.phoneNumberAlt.trim();
			const subdistrictId = this.subdistrictId;
			const location = {
				address,
				store_phone: phoneNumber,
				store_phone_alt: phoneNumberAlt,
				province: this.provinceName,
				city: this.cityName,
				subdistrict: this.subdistrictName,
				subdistrict_id: subdistrictId,
				zip: this.zip,
				origin: this.origin,
			};
			const locationJson = JSON.stringify(location);
			const params = {
				order_ids: idsJson,
				courier: this.selectedCourier,
				pickup_location: locationJson,
				pickup_date: this.date,
				pickup_time: this.time,
				method: this.method,
			};
			return params;
		},
		isOrdersTresholdValid() {
			let valid = true;
			let treshold = 0;
			if (this.selectedCourier === 'jnt' && this.method === SHIPMENT_METHODS.PICKUP) {
				treshold = 5;
			}
			if (this.orders.length < treshold) {
				valid = false;
			}
			return valid;
		},
		isValid() {
			return this.orders.length > 0
				&& this.invalidOrders.length === 0
				&& this.invalidOrdersCourier.length === 0
				&& this.invalidOrdersAddress.length === 0
				&& this.isOrdersTresholdValid
				&& this.origin
				&& this.origin !== ''
				&& this.address.trim() !== ''
				&& this.phoneNumber.trim() !== ''
				&& this.phoneNumberAlt.trim() !== ''
				&& !this.isNotSupported;
		},
		isNotSupported() {
			// return this.subdistrictId !== 0 && (!this.origin || this.origin === '');
			// return this.subdistrictId !== 0 && this.courier && this.courier.key === 'sicepat';
			let isNotSupported = this.cityId !== 0 && (!this.origin || this.origin === '');
			if (this.selectedCourier === 'ninja') {
				isNotSupported = !this.subdistrict || !this.subdistrict.ninja_pickup;
			}
			return isNotSupported;
		},
		courierErrorLabel() {
			const courierLabel = this.getCourierLabel(this.selectedCourier);
			// return `${courierLabel} currently doesn't have pickup service at ${this.cityName}`;
			let label = `${courierLabel} saat ini tidak dapat melakukan pickup ke daerah ${this.cityName}`;
			if (this.subdistrictName) {
				label = `${label}, ${this.subdistrictName}`;
			}
			return label;
		},
		selectedCourierLabel() {
			return this.getCourierLabel(this.selectedCourier);
		},
		isPickup() {
			return this.method === 'PICKUP';
		},
		isDrop() {
			return this.method === 'DROP';
		},
		invalidOrdersAddress() {
			const filter = ((order) => {
				// eslint-disable-next-line camelcase
				const address = order?.customer_data?.address ?? '';
				return address === '';
			});
			const orders = this.orders.filter(filter);
			return orders;
		},
	},
	created() {
		if (this.user) {
			this.setData();
		}
	},
	watch: {
		user(user) {
			if (user) {
				this.setData();
			}
		},
		selectedCourier(courier) {
			this.checkTime(this.time);
			if (courier === 'jne') {
				this.method = SHIPMENT_METHODS.PICKUP;
			}
		},
		subdistrict(subdistrict) {
			if (subdistrict) {
				this.initDateTime();
			}
		},
	},
};
</script>
